import { render, staticRenderFns } from "./workUpload.vue?vue&type=template&id=d7bae2a4&scoped=true"
import script from "./workUpload.vue?vue&type=script&lang=js"
export * from "./workUpload.vue?vue&type=script&lang=js"
import style0 from "./workUpload.vue?vue&type=style&index=0&id=d7bae2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bae2a4",
  null
  
)

export default component.exports